import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { Layout } from "../../../styles/layout";
import CashSessionsStore from "../cash_sessions.store";
import BusinessUnitsStore from "../../business_units/business_units.store";
import { SelectView, TextArea } from "../../../styles/form";
import { Button } from "../../../styles/button";
import AppStore from "../../../app.store";
import { hasPermission } from "../../../utils/hasPermission";
import { PermissionGroup } from "../../../utils/permission";
import CurrencyInput from "../../../components/currency-input/currency-input.view";

interface Props {
    onClose: () => void;
}

export const OpenCashSessionModal = observer(({ onClose }: Props) => {
    const { businessUnits } = BusinessUnitsStore;
    const { permissions, userData } = AppStore;
    const [businessUnitId, setBusinessUnitId] = useState<number | undefined>(undefined);
    const [openingCash, setOpeningCash] = useState<number>(0);
    const [note, setNote] = useState<string>("");
    const [isLoading, setIsLoading] = useState(false);

    const canManage = permissions && hasPermission(permissions, PermissionGroup.CASHIER_SESSION, 'MANAGE');

    useEffect(() => {
        if (!canManage && userData?.business_unit_id) {
            setBusinessUnitId(userData.business_unit_id);
        }
    }, [canManage, userData]);

    const handleOpen = async () => {
        if (!businessUnitId) return;
        setIsLoading(true);
        const success = await CashSessionsStore.openCashSession({
            business_unit_id: businessUnitId,
            opening_cash: openingCash,
            note: note || undefined
        });
        setIsLoading(false);
        if (success) {
            onClose();
        }
    };

    const buOptions = businessUnits?.map(bu => ({
        label: bu.name,
        value: bu.id
    }));

    return (
        <Layout vertical between={15} padding="10px" hAlign="center">
            <Layout vertical between={15} style={{ width: "100%" }}>
                {canManage && (
                    <div>
                        <label>Торговая точка</label>
                        <SelectView
                            value={businessUnitId}
                            onChange={(e) => setBusinessUnitId(Number(e.target.value))}
                            style={{ width: "100%" }}
                        >
                            <option value="">Выберите торговую точку</option>
                            {buOptions?.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </SelectView>
                    </div>
                )}
                <div>
                    <label>Начальная сумма в кассе</label>
                    <CurrencyInput
                        value={openingCash}
                        onChange={(value) => setOpeningCash(value)}
                        min={0}
                        style={{ width: "100%" }}
                        placeholder="Введите сумму"
                    />
                </div>
                <div>
                    <label>Примечание</label>
                    <TextArea
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        placeholder="Добавьте примечание (опционально)"
                        rows={6}
                        style={{ width: "100%" }}
                    />
                </div>
            </Layout>
            <Button
                extent="L"
                onClick={handleOpen}
                disabled={!businessUnitId || isLoading}
            >
                Открыть кассу
            </Button>
        </Layout>
    );
});
